import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { resetCompletion } from './redux/actions';
import snakeCase from 'lodash/snakeCase';

import { favoriteEpisodeVideo, unfavoriteEpisodeVideo } from '../library/favorites/redux/actions';

import { selectList, selectCurrentShow } from './redux/selectors';
import EpisodeDescription from './common/EpisodeDescription';
import NextEpisode from './common/NextEpisode';
import Icon from '../../common/icons/Icon';
import moment from 'moment';
import { sendIntercomEvent } from '../../common/events';

class Episodes extends Component {
  static propTypes = {
    show: PropTypes.object.isRequired,
    episodes: PropTypes.array.isRequired,
    episodesLoaded: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    const { show } = this.props;
    sendIntercomEvent(`viewed_${snakeCase(show.name)}`);
  };

  handlePlay = (showId, episodeId, shouldResetCompletion) => {
    if (shouldResetCompletion) {
      this.props.dispatch(resetCompletion(showId));
    }
    this.props.history.push(`/subscription/tv/${showId}/${episodeId}?autoplay`);
  };

  handleFavoriteToggle = (e, episodeId) => {
    e.preventDefault();
    const { dispatch, episodes } = this.props;
    const episode = episodes.find(episode => episode.id === episodeId);
    const action = episode.favorited ? unfavoriteEpisodeVideo : favoriteEpisodeVideo;

    dispatch(action(episodeId)).then(() => {
      const eventName = episode.favorited ? 'unfavorite_tv' : 'favorite_tv';
      sendIntercomEvent(eventName, { episodeName: episode.name });
    });
  };

  renderHero = () => {
    const { episodes, location, match, show } = this.props;
    let resetCompletion = false;
    let unwatchedIndex = episodes.findIndex(episode => !episode.video.complete);
    if (unwatchedIndex === -1) {
      resetCompletion = true;
      unwatchedIndex = 0;
    }
    const episode = episodes[unwatchedIndex];

    if (episode && location.search === '?featured') {
      return <Redirect to={`/subscription/tv/${match.params.showId}/${episode.id}?autoplay`} />;
    } else if (!episode) {
      return null;
    }

    let buttonText = 'Play';

    if (episode.video.progress) {
      buttonText = 'Resume';
    }

    if (resetCompletion) {
      buttonText = 'Watch Again';
    }

    return (
      <div
        className="hero__wrapper"
        style={episode.image ? { backgroundImage: `url(${episode.image.location})` } : null}
      >
        <div className="container">
          <div className="tv__hero">
            <Link to="/subscription/tv">
              <button className="button__back-button">
                <Icon icon="BackArrow" /> Back to All Shows
              </button>
            </Link>
            <div className="show__title">
              <h1>{show.name}</h1>
              <NextEpisode time={show.next_episode} />
            </div>
            <div className="episode__information">
              <h3>
                Episode {unwatchedIndex + 1}: <span>"{episode.name}"</span>{' '}
              </h3>
              <p>{episode.description}</p>
              <span className="episode__duration">
                {Math.round(moment.duration(1000 * episode.video.duration).asMinutes())}m
              </span>
            </div>
            <div className="tv__hero__buttons">
              <button
                type="button"
                className="button button--icon"
                onClick={this.handlePlay.bind(this, show.id, episode.id, resetCompletion)}
              >
                <Icon icon="PlayCircle" />
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderEpisodes = () => {
    const { favoriting, unfavoriting } = this.props;

    if (!this.props.episodes.length) {
      return null;
    }

    return (
      <div className="show__list">
        <div className="container">
          <h3>All Episodes</h3>
          <div className="shows__wrapper">
            {this.props.episodes.map((episode, index) => {
              const favoriteActionLoading = favoriting.get('episodeId') === episode.id && favoriting.get('loading');
              const unfavoriteActionLoading =
                unfavoriting.get('episodeId') === episode.id && unfavoriting.get('loading');

              let favoriteIcon;

              if (favoriteActionLoading || unfavoriteActionLoading) {
                favoriteIcon = 'Saving';
              } else {
                favoriteIcon = episode.favorited ? <Icon icon="Favorite" /> : <Icon icon="UnFavorite" />;
              }

              return (
                <EpisodeDescription
                  key={episode.id}
                  showId={parseInt(this.props.match.params.showId, 10)}
                  episodeId={episode.id}
                  episodeIndex={index + 1}
                  name={episode.name}
                  description={episode.description}
                  duration={episode.video.duration}
                  progress={episode.video.progress}
                  complete={episode.video.complete}
                  image={episode.image.location}
                  onFavoriteToggle={this.handleFavoriteToggle}
                  favoriteIcon={favoriteIcon}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  renderShowInformation = () => {
    const { show } = this.props;
    return (
      <div className="show__information">
        <div className="container">
          <div className="show__title">
            <h1>{show.name}</h1>
            <NextEpisode time={show.next_episode} />
          </div>
          <p>{show.description}</p>
        </div>
      </div>
    );
  };

  render() {
    const { episodesLoaded } = this.props;

    if (!episodesLoaded) {
      return null;
    }

    return (
      <div>
        {this.renderHero()}
        {this.renderEpisodes()}
        {this.renderShowInformation()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  show: selectCurrentShow(state.subscription.tv.shows, props.match.params.showId),
  episodesLoaded: state.subscription.tv.episodes.get('loaded'),
  episodes: selectList(state.subscription.tv.episodes),
  favoriting: state.subscription.favorites.favoritingEpisode,
  unfavoriting: state.subscription.favorites.unfavoritingEpisode,
});

export default connect(mapStateToProps)(Episodes);



// WEBPACK FOOTER //
// ./src/subscription/tv/Episodes.js